<audio #mp3 src="/assets/audio/{{audio.file}}.mp3"></audio>

<div class="audio-player" id="{{title}}-audio-player-{{index}}">
  <p>{{audio.name}}</p>

  <span class="button">
    <a *ngIf="!isPlaying" id="{{title}}-play-btn-{{index}}" class="play" (click)="mp3.play(); updateProgress(mp3); isPlaying = !isPlaying"></a>

    <a *ngIf="isPlaying" id="{{title}}-pause-btn-{{index}}" class="pause" (click)="mp3.pause(); updateProgress(mp3); isPlaying = !isPlaying"></a>

    <mat-progress-spinner *ngIf="percent > 0" [value]="percent" mode="determinate" diameter="30">
    </mat-progress-spinner>

  </span>
</div>